// ============================================================
// src/api.js  —  All calls to your PHP backend
// Base URL auto-detects dev vs production
// ============================================================

const BASE = process.env.NODE_ENV === 'production'
  ? 'https://comics.tomory.net/api'
  : 'http://localhost/comics.tomory.net/api'; // XAMPP local dev

const req = async (method, path, body = null) => {
  const opts = {
    method,
    credentials: 'include', // sends session cookie
    headers: { 'Content-Type': 'application/json' },
  };
  if (body) opts.body = JSON.stringify(body);

  const res  = await fetch(BASE + path, opts);
  const json = await res.json();

  if (!json.ok) throw new Error(json.error || `HTTP ${res.status}`);
  return json.data;
};

// ── Auth ──────────────────────────────────────────────────────
export const auth = {
  // These redirect the full page to the OAuth provider
  googleLoginUrl:   () => BASE + '/auth/google/login',
  facebookLoginUrl: () => BASE + '/auth/facebook/login',

  me:     () => req('GET',  '/auth/me'),
  logout: () => req('POST', '/auth/logout'),
};

// ── User preferences ──────────────────────────────────────────
export const user = {
  update: (data) => req('PUT', '/user', data),
};

// ── Profiles ─────────────────────────────────────────────────
export const profiles = {
  list:   ()           => req('GET',    '/profiles'),
  create: (data)       => req('POST',   '/profiles', data),
  update: (id, data)   => req('PUT',    `/profiles?id=${id}`, data),
  remove: (id)         => req('DELETE', `/profiles?id=${id}`),
};

// ── Comics ────────────────────────────────────────────────────
export const comics = {
  list:   (profileId, params = {}) => {
    const qs = new URLSearchParams({ profile_id: profileId, ...params }).toString();
    return req('GET', `/comics?${qs}`);
  },
  // Dashboard: full list with all columns, sort, filter, pagination
  dashboard: (profileId, params = {}) => {
    const qs = new URLSearchParams({ profile_id: profileId, mode: 'dashboard', ...params }).toString();
    return req('GET', `/comics?${qs}`);
  },
  add:    (data)   => req('POST',   '/comics', data),
  update: (id, d)  => req('PUT',    `/comics?id=${id}`, d),
  remove: (id)     => req('DELETE', `/comics?id=${id}`),
  valuation: (comicId) => req('GET', `/comics/valuation?comic_id=${comicId}`),
};

// ── Admin ─────────────────────────────────────────────────────
export const admin = {
  stats:           ()              => req('GET',    '/admin/stats'),
  listUsers:       ()              => req('GET',    '/admin/users'),
  updateRole:      (id, role)      => req('PUT',    `/admin/users?id=${id}`, { role }),
  deleteUser:      (id)            => req('DELETE', `/admin/users?id=${id}`),
  enrichLogs:      ()              => req('GET',    '/admin/enrichlogs'),
  loginHistory:    (userId)        => req('GET',    `/admin/loginhistory${userId ? `?user_id=${userId}` : ''}`),
  checkInactivity: (dryRun, days)  => req('GET',    `/admin/inactivity?dry_run=${dryRun?'1':'0'}&days=${days||90}`),
};
export const importExport = {
  // Export returns a CSV string directly
  exportCsv: (profileId) => {
    return fetch(BASE + `/importexport?action=export&profile_id=${profileId}`, {
      credentials: 'include',
    }).then(r => r.text());
  },
  // Import: send array of row objects, get back results per row
  importRows: (profileId, rows) => req('POST', '/importexport', { profile_id: profileId, rows }),
};
export const lookup = {
  barcode: (code)           => req('GET', `/lookup?type=barcode&q=${encodeURIComponent(code)}`),
  search:  (q, source)      => req('GET', `/lookup?type=search&q=${encodeURIComponent(q)}&source=${source}`),
  saveKeys: (keys)          => req('PUT', '/lookup/apikeys', keys),  // keys: {comicvine, googlebooks}
  keyStatus: ()             => req('GET', '/lookup/apikeys?type=apikeys&action=apikeys'),
};
